import { Link } from "react-router-dom"

export function Logo(): JSX.Element {
  return (
    <Link to="/">
      <img src="/assets/SR_logo.svg" className="logo" height="48px" />
    </Link>
  )
}
